import { render, staticRenderFns } from "./error.vue?vue&type=template&id=c62845c4&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c62845c4')) {
      api.createRecord('c62845c4', component.options)
    } else {
      api.reload('c62845c4', component.options)
    }
    module.hot.accept("./error.vue?vue&type=template&id=c62845c4&", function () {
      api.rerender('c62845c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exception/error.vue"
export default component.exports